/**
 * Help button for the driver dashboard — re-launches the driver tour.
 * Same look & feel as OnboardingHelpButton, role-specific hook.
 */

import React from "react";
import { Question } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";
import { useDriverOnboarding } from "./useDriverOnboarding";

export default function DriverOnboardingHelpButton({ className = "" }) {
  const { user } = useAuth();
  const { start, reset } = useDriverOnboarding(user);

  const handleClick = () => {
    reset();
    start();
  };

  return (
    <Button
      data-testid="driver-onboarding-help-btn"
      variant="ghost"
      size="sm"
      onClick={handleClick}
      title="Revoir le guide"
      aria-label="Revoir le guide de prise en main"
      className={
        "text-zinc-400 hover:text-amber-400 hover:bg-zinc-800 px-2 " + className
      }
    >
      <Question size={18} weight="bold" />
    </Button>
  );
}
